import React from "react"
import Tooltip from "../Tooltip"
import { FormattedMessage } from "react-intl"
import classNames from "classnames"

import { capitalizeString } from "../../../util/format"
import { copyToClipboard } from "../../../util/util"

const scoreDetailMeta = [
  {
    propertyName: "experience",
    title: "common.experience",
  },
  {
    propertyName: "education",
    title: "common.education",
  },
  {
    propertyName: "hard_skills",
    title: "common.hardSkills",
  },
  {
    propertyName: "soft_skills",
    title: "common.softSkills",
  }
]

function CandidateScore({ matchData, cvData }) {

  if (!matchData || !matchData.score_dict || !matchData.score_meta) {
    return <p className="cvData-info-not-found">
      <FormattedMessage id={"candidate.notFound"} />
    </p>
  };

  const { score_dict, score_meta } = matchData
  const cvInformation = cvData?.information;

  return (
    <div className="candidate_container">
      {cvInformation && (
        <div className="box flex">
          <div className="contact-details flex-col">
            {cvInformation.phone
              ?.filter(Boolean)
              ?.map((number, index) => (
                <Tooltip tooltip={"Click to copy"} key={`Phone - ${index}`}>
                  <p onClick={() => copyToClipboard(number)}>
                    <span><FormattedMessage id={"common.phone"} /></span> {number}
                  </p>
                </Tooltip>
              ))}

            {cvInformation.email
              ?.filter(Boolean)
              ?.map((email, index) => (
                <Tooltip tooltip={"Click to copy"} key={`Email - ${index}`}>
                  <p onClick={() => copyToClipboard(email)}>
                  <span><FormattedMessage id={"common.email"} /></span> {email}
                  </p>
                </Tooltip>
              ))}

            {cvInformation.website !== "N/A" && (
              <Tooltip tooltip={"Click to copy"}>
                <p onClick={() => copyToClipboard(cvData.website)}>
                <span><FormattedMessage id={"common.website"} /></span> {cvInformation.website}
                </p>
              </Tooltip>
            )}

            {cvInformation.dateOfBirth && (
              <p>
                <span><FormattedMessage id={"common.dateOfBirth"} /></span> {cvInformation.dateOfBirth}
              </p>
            )}

            {cvInformation.address?.country && (
              <p>
                <span><FormattedMessage id={"common.address"} /></span>
                {cvData.information.address?.street && ` ${cvData.information.address.street}, `}
                {cvData.information.address?.city && ` ${cvData.information.address.city}, `}
                {cvData.information.address?.zip && ` ${cvData.information.address?.zip}, `}
                {cvData.information.address?.country && ` ${cvData.information.address.country}`}
              </p>
            )}
          </div>
        </div>
      )}

      {scoreDetailMeta
        .filter(({ propertyName }) => score_dict[propertyName])
        .map(({ propertyName, title }) => {
          const sectionData = Object.entries(score_dict[propertyName]);
          const score = score_meta[propertyName];

          return (
            <div className="box flex" key={propertyName}>
              <div className="sectionName flex-col">
                <div
                  className="pieOuter"
                  style={{
                    background: `conic-gradient(var(--fribl-blue) ${
                      /* score to angle for circle border */
                      score * 36
                    }deg, var(--light-grey) 0deg)`,
                  }}
                >
                  <p>{Math.round(score)}</p>
                </div>

                <p className="skillType">
                  <b>
                    <FormattedMessage id={title} />
                  </b>{" "}
                </p>
              </div>

              <div className="section-card">
                {sectionData.map(
                  ([name, details], index) => (
                    <div key={name}>
                      <div className={classNames("row", {
                        "row__large": sectionData.length <= 1,
                        "row__last": index === sectionData.length - 1,
                      })}>
                        <strong
                          className="score"
                          style={{ opacity: Math.max(details.score / 10, 0.1) }}
                        >
                          {details.score}
                        </strong>
                        <div className="nameEvidenceContainer">
                          {details.score > 0 ? (
                            <strong className="name">{capitalizeString(name)}</strong>
                          ) : (
                            <p className="name weak">
                              {capitalizeString(name)} <em>No&nbsp;evidence</em>
                            </p>
                          )}
                          <div className="evidence">
                            <em>Evidence: </em>
                            {details.explanation}
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default CandidateScore